import React from 'react'

const PagesContext = React.createContext([])

export default PagesContext
